import { Layout as AntLayout } from 'antd';
import styled from 'styled-components';
export const Layout = styled(AntLayout)`
  .ant-layout-content {
    background: var(--white-100);
  }
`;
